// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__xCq5K","backdrop":"Modal_backdrop__CMJeN"};